import { baseApiForNurse } from "./baseApi";

export const batchesApi = baseApiForNurse.injectEndpoints({
    credentials: "include",
    endpoints: (builder) => ({
        getBatchByTrainingId: builder.query({
            query: (id) => {
                return {
                    url: "/training-batch?training_id=" + id,
                    method: "GET",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            providesTags: ['batch'],
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
        }),

        enrollBatch: builder.mutation({
            query: (data) => {
                return {
                    url: "training-enrollment",
                    method: "POST",
                    body: data,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            invalidatesTags: ['batch'],
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
        }),
    }),
});

export const {
    useGetBatchByTrainingIdQuery,
    useEnrollBatchMutation
} = batchesApi;
